<div class="chips-item"
     [ngClass]="{
       'selected': isSelected,
       'disabled': isDisabled
     }">
  <input class="chips-item__input" type="radio"
         [name]="name"
         [value]="value"
         [checked]="isChecked"
         [disabled]="isDisabled"
         (change)="onSelect.emit()">
  <div class="chips-item__content">
    <ng-content></ng-content>
  </div>
</div>
